import { mapState } from 'vuex'

const helpers = {
  install (Vue, options) {
    Vue.mixin({
      data () {
        return {
          locale: localStorage.getItem('locale') || 'en',
          administrators: [
            process.env.VUE_APP_ROLE_ADMIN,
            'admin'
          ]
        }
      },
      computed: {
        ...mapState({
          userRoles: state => state.user.data ? state.user.data.roles : null,
          userPermissions: state => state.user.data ? state.user.data.permissions : null
        }),
        baseUrl () {
          return process.env.VUE_APP_API
        }
      },
      methods: {
        getDateFormat (date, format = process.env.VUE_APP_DATE_FORMAT) {
          try {
            if (this.$moment(date, 'YYYY-MM-DD hh:mm:ss').isValid()) {
              return this.$moment(date, 'YYYY-MM-DD hh:mm:ss').format(format)
            }
            return this.$t('string.na')
          } catch (error) {
            return date
          }
        },
        getSrc (url) {
          if (!url) {
            return ''
          } else if (url.startsWith('http')) {
            return url
          } else {
            if (url.startsWith('/')) {
              return process.env.VUE_APP_API + url
            } else {
              return process.env.VUE_APP_API + '/' + url
            }
          }
        },
        // Prompt confirm promise
        onConfirm (options) {
          const self = this
          return new Promise((resolve, reject) => {
            this.$swal.fire(Object.assign({
              title: self.$t('label.swal.title'),
              text: self.$t('label.swal.desc'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: self.$t('label.swal.no'),
              confirmButtonText: self.$t('label.swal.yes')
            }, options)).then((result) => {
              if (result.value) {
                resolve({
                  accept: true
                })
              } else {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                  accept: false
                })
              }
            })
          })
        },
        getName (object) {
          if (object) {
            if (object.hasOwnProperty('name_' + this.$i18n.locale)) {
              return object['name_' + this.$i18n.locale]
            } else if (object.hasOwnProperty('name')) {
              return object.name
            } else if (object.hasOwnProperty('title')) {
              return object.title
            }
          }
          return this.$t('label.na')
        },
        showSwalSuccess () {
          this.$swal({
            title: this.$t('label.swal.deleteLabel'),
            text: this.$t('label.swal.success'),
            type: 'success',
            confirmButtonText: this.$t('button.ok')
          })
        },
        showToastr () {
          this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
        },
        onResponseError (error) {
          let message = this.$t('string.somethingWentWrong')
          if (error.statusText) {
            message = error.statusText
          } else if (error.response && error.response.status) {
            message = error.response.data.message
            try {
              if (message && message['message_' + this.$i18n.locale]) {
                message = message['message_' + this.$i18n.locale]
              } else {
                message = error.response.statusText
              }
            } catch (e) {
              message = this.$t('string.somethingWentWrong')
            }
          }
          this.$toastr('error', message, this.$t('string.error'))
        },
        getUserInfo () {
          this.$axios.post(this.$base_api + '/api/backend/user/get-roles-and-permissions')
            .then(async (response) => {
              if (response && response.data && response.data.data) {
                const { user, roles, permissions } = response.data.data
                await this.$store.dispatch('user/setUser', { user })
                await this.$store.dispatch('user/setRoles', roles)
                await this.$store.dispatch('user/setPermissions', permissions)
              }
            }).catch((error) => {
              this.onResponseError(error)
            })
        },
        clearEventHandler (classNames) {
          classNames.map((className) => {
            return $(document).off('click', className)
          })
        },
        can (permissions) {
          if (!permissions || permissions.length === 0 || this.$store.getters['user/isAdmin']) {
            return true
          }

          if (!this.userPermissions) {
            return false
          }

          return this.userPermissions.some(permission => permissions.includes(permission))
        },
        hasRoles (roles) {
          return this.$store.getters['user/isAdmin'] || this.onlyHasRoles(roles)
        },
        onlyHasRoles (roles) {
          if (!roles || roles.length === 0) {
            return true
          }

          if (!this.userRoles) {
            return false
          }

          return this.userRoles.some(role => roles.includes(role))
        },
        isAdmin () {
          if (!this.userRoles) {
            return false
          }
          return this.userRoles.some(role => this.administrators.includes(role))
        },
        onResizeWindow () {
          $(function () {
            $(window).resize()
            $(window).resize()
          })
        }
      }
    })
  }
}

export default helpers
